import React, { useState, useEffect } from "react";
import {
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Badge,
} from "reactstrap";
import { formatDate } from "../../Utilities/dateUtils";
import { formatPrice } from "../../Utilities/priceUtils";
import DatePicker from "react-datepicker";
import { FormattedMessage, useIntl } from "react-intl";
import useCartStore from "../../stores/useCartStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { v4 as uuid } from "uuid";
import RequestAplDemoPopover from "./RequestAplDemoPopover";

export default function PlusPackageVariantSelectOptionalModal({
  isOpen,
  toggle,
  selectedPlusPackageVariant,
  setSelectedPlusPackageVariant,
  selectedPlusPackage,
  currency,
  onProceed,
}) {
  const intl = useIntl();
  const [errors, setErrors] = useState([]);
  const [articleExistsInCart, setArticleExistsInCart] = useState(null);
  const cartResult = useCartStore((s) => s.result);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.PUBLIC_URL}/settings.json?rndstr=${uuid()}`)
      .then((res) => {
        setSettings(res.data);
      });
  }, []);

  const handleSetPackage = () => {
    let hasErrors = false;
    if (Object.keys(selectedPlusPackageVariant).length === 0) {
      hasErrors = true;
      setErrors(["noVariant", "noStartDate"]);
    } else {
      if (!selectedPlusPackageVariant.option) {
        hasErrors = true;
        setErrors(["noVariant"]);
      }
      if (
        !selectedPlusPackageVariant.startDate &&
        articleExistsInCart === null
      ) {
        hasErrors = true;
        setErrors(["noStartDate"]);
      }
      if (
        selectedPlusPackageVariant.startDate !== undefined &&
        formatDate(selectedPlusPackageVariant.startDate, "yyyyMMdd") <
          formatDate(new Date(), "yyyyMMdd")
      ) {
        hasErrors = true;
        setErrors(["startDateTooEarly"]);
      }
      if (!hasErrors) {
        onProceed(true);
      }
    }
  };

  const handleSetVariant = (option) => {
    if (
      cartResult.some((item) => item.fortnoxNumber === option.fortnoxNumber)
    ) {
      setArticleExistsInCart(
        cartResult.find((item) => item.fortnoxNumber === option.fortnoxNumber)
          .startDate
      );
    } else {
      setArticleExistsInCart(null);
    }
    setSelectedPlusPackageVariant({
      ...selectedPlusPackageVariant,
      option: {
        ...option,
        name: option.name,
        type: selectedPlusPackage.productVariant.type,
      },
    });
    setErrors(errors.filter((err) => err !== "noVariant"));
  };

  const handleSetStartDate = (date) => {
    setSelectedPlusPackageVariant({
      ...selectedPlusPackageVariant,
      startDate: date,
    });
    setErrors(
      errors.filter(
        (err) => err !== "noStartDate" && err !== "startDateTooEarly"
      )
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size={
        settings?.LicenseAplShopVideo !== undefined &&
        settings?.LicenseAplShopVideo.length > 1
          ? "lg"
          : "md"
      }
    >
      <ModalHeader>
        <FormattedMessage id="DoYouWantToAddPremiumPackage" />?
      </ModalHeader>
      <ModalBody>
        {settings?.LicenseAplShopVideo !== undefined &&
          settings?.LicenseAplShopVideo.length > 1 && (
            <div
              className="video-responsive"
              style={{ marginBottom: "2em", height: "31em" }}
            >
              <iframe
                style={{ width: "100%", height: "100%" }}
                src={settings?.LicenseAplShopVideo}
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                allowFullScreen
                title="Embedded"
              />
            </div>
          )}
        <Row className="justify-content-end">
          <Col style={{ flexGrow: "0", textWrapMode: "nowrap" }}>
            <RequestAplDemoPopover width={"200px"} />
          </Col>
        </Row>
        <span>
          <FormattedMessage id="YouCanAddPremiumPackageToPurchase" />
        </span>
        <div
          className={
            errors.includes("noVariant") ? "selectPlusPackageVariantError" : ""
          }
        >
          {selectedPlusPackage?.productVariant?.options?.map((option, i) => {
            return (
              <Row className={"pt-3"} key={"plusvariant" + i}>
                <Col>
                  <Button
                    color="success"
                    outline
                    style={{ width: "100%" }}
                    active={
                      selectedPlusPackageVariant?.option?.fortnoxNumber ===
                      option.fortnoxNumber
                    }
                    onClick={() => handleSetVariant(option)}
                  >
                    <div
                      className="d-flex"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div
                        style={{ display: "inline-block", paddingLeft: "1em" }}
                      >
                        <FormattedMessage id="YearsCount" values={{ years: option.years }} />
                      </div>
                      <div
                        style={{
                          display: "inline-block",
                          paddingLeft: ".8em",
                          paddingRight: ".8em",
                        }}
                      >
                        <Badge pill color="light" className="p-2 ">
                          {formatPrice(
                            (option.priceStudent !== undefined
                              ? option.priceStudent
                              : option.salesPrice) / option.years,
                            currency,
                            intl,
                          )}
                          /<FormattedMessage id="License" />{" "}
                          <FormattedMessage id="PerYear" />
                        </Badge>
                      </div>
                    </div>
                  </Button>
                </Col>
              </Row>
            );
          })}
        </div>
        <Row className="pt-2">
          <Col>
            <Label for="date">
              <FormattedMessage id="ChooseStartDateForAplLicense" />:
            </Label>
          </Col>
        </Row>
        <div
          className={
            errors.includes("noStartDate") ||
            errors.includes("startDateTooEarly")
              ? "selectPlusPackageVariantError"
              : ""
          }
        >
          <Row>
            {articleExistsInCart !== null ? (
              <Col>
                <FontAwesomeIcon icon="info" className="me-2" />
                <FormattedMessage
                  values={{
                    date: formatDate(articleExistsInCart, "yyyy-MM-dd"),
                  }}
                  id="YouAlreadyHaveArticleInCartWithStartDate"
                />
              </Col>
            ) : (
              <Col>
                <DatePicker
                  selected={selectedPlusPackageVariant.startDate}
                  onChange={(value) => handleSetStartDate(value)}
                  locale="sv"
                  dateFormat="yyyy-MM-dd"
                  readOnly={articleExistsInCart}
                  className="input date--picker"
                />
                {errors.includes("noStartDate") ? (
                  <span className="text-danger input-feedback">
                    <FormattedMessage id="YouHaveToChooseAStartDate" />
                  </span>
                ) : errors.includes("startDateTooEarly") ? (
                  <span className="text-danger input-feedback">
                    <FormattedMessage id="StartDateCannotBePriorToToday" />
                  </span>
                ) : (
                  ""
                )}
              </Col>
            )}
          </Row>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={toggle}>
          <FormattedMessage id="GoBack" />
        </Button>
        <Button outline color="primary" onClick={() => onProceed(false)}>
          <FormattedMessage id="Skip" />
        </Button>
        <Button outline color="primary" onClick={() => handleSetPackage()}>
          <FormattedMessage id="Add" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}
